import { Action } from "@ngrx/store";

export const closeJobComponentInitialState = {
  closedReason: undefined as string | undefined,
  closedReasonsDialogPromptedBy: undefined as Action | undefined,
} as const;
